<template>
  <div>
    <div class="policy_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <span>
            <div class="mobiFaq">
              <h2 class="mobiTitle sm text_color">podmienky a požiadavky</h2>
              <p class="mobitxt">&nbsp;</p>
            </div>
          </span>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Použiteľnosť</h2>
            <p class="mobitxt">
              Termíny a podmienky uvedené nižšie (Všeobecné podmienky) sa
              vzťahujú na Slovenskú verziu jednorazovej platenej služby Miximo
              Premium (Puretech Global Sdn Bhd a /alebo Služba) ponúkanú on -
              line cez internet od Puretech Global Sdn Bhd (ďalej len Puretech
              Global Sdn Bhd ). Koncový užívateľ požaduje službu GAMEBOX
              Puretech Global Sdn Bhd .
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Všeobecné</h2>
            <p class="mobitxt">
              GAMEBOX poskytuje najlepšie sexy tapety a videá exkluzívne pre váš
              mobil.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Potvrdenie / Registrácia</h2>
            <p class="mobitxt">
              Na vstup do služby GAMEBOX musí Koncový používateľ zadať svoje
              mobilné telefónne číslo a /alebo niektoré ďalšie údaje a /alebo
              informácie prostredníctvom propagačnej webovej stránky (Vstupné
              Stránky) prevádzkovanej Puretech Global Sdn Bhd -om. Potom Koncový
              užívateľ dostane SMS vo svojom mobilnom zariadení, s Osobným
              Identifikačným Číslom (PIN kód), alebo tzv ponukovú správu s
              informáciami o službe. Zadaním obdržaného PIN kódu na vstupnej
              stránke a /alebo zaslaním potvrdzovacej správy a /alebo používaním
              služby Koncový užívateľ uznáva a potvrdzuje, že prečítal Všeobecné
              obchodné podmienky, je oprávneným držiteľom mobilného účtu za
              telefón, alebo má súhlas platiteľa telefóneho účtu používať túto
              službu. Koncový užívateľ dostane potvrdzujúcu SMS správu o
              úspešnej aktivácii GAMEBOX služby, spôsobe, frekvencii a nákladov
              na prevzatie Služby, rovnako ako presné detaily odhlásenia.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Náklady a Poplatky</h2>
            <p class="mobitxt">
              GAMEBOX je platená služba ktorá stojí 3 SMS x 1.60 EUR / týždeň
              Poplatok bude účtovaný na mobilný telefónny účet, alebo
              predplatené mobilné číslo.Spôsob nabíjania je Premium MT SMSkami
              odoslanými na Koncového užívateľa na základe jeho žiadosti o
              službu GAMEBOX. Táto správa bude obsahovať prihlasovacie údaje k
              službe GAMEBOX. Poplatky sú vyberané podľa Prevádzkovateľov
              Mobilných Sietí. Poplatky sú odpísané proti účtu Koncového
              užívateľa Prevádzkovateľom, v prípade predplantnej SIM sa poplatky
              odpočítajú s kreditu Koncového užívateľa. Koncový užívateľ týmto
              výslovne udeľuje jeho alebo jej oprávnenie pre nabíjanie, a
              zaväzuje sa na zaplatenie v plnej výške za poplatky, ktoré vznikli
              v dôsledku upísania a / alebo používania služby GAMEBOX. Ak nie
              ste osoba zodpovedná za zaplatenie mobilného účtu, prosím,
              získajte povolenie od platiteľa mobilu pred prihlásením a /alebo
              používaním služby GAMEBOX. Svojím podpisom a /alebo účasťou na
              službe, Puretech Global Sdn Bhd predpokladá, že Koncový užívateľ
              získal potrebné povolenie, súhlas alebo schválenie od platiteľa
              mobilného účtu, opatrovníka alebo rodičov. Všetky SMS správy
              zaslané Koncovým používateľom budú účtované mobilným operátorom
              Koncového užívateľa štandardnou tarifou. Tieto tarify sa môžu
              líšiť podľa operátora. Prosím, pre viac nformácií o uložených
              poplatkoch kontaktujte svojho GSM operátora.
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Pomoc a podpora</h2>
            <p class="mobitxt">
              Zákaznícky servis je k dispozícii v pracovných dňoch od 09:00 do
              17:00 Kontakt: +421 313215999 alebo gamebox.sk@silverlines.info
            </p>
          </div>
          <div class="mobiFaq">
            <h2 class="mobiTitle sm text_color">Duševné vlastníctvo</h2>
            <p class="mobitxt">
              Službu môžete použiť na svoje osobné nekomerčné použitie. Termín
              GAMEBOX a všetky ostatné ochranné známky, servisné značky a /alebo
              obchodné názvy používané GAMEBOX-om na Službe z času na čas
              (Ochranné Známky), sú ochrannými známkami, servisnými značkami a
              /alebo obchodnými názvami Puretech Global Sdn Bhd - u alebo jednej
              z jeho spoločností v skupine alebo udeľovateľov jej licencie, a
              tieto subjekty si vyhradzujú všetky práva na Ochranné Známky.
              Okrem toho, ďalší obsah Služby, vrátane, ale nie výhradne, Hry,
              obrázy, obrázky, grafika, fotografie, animácie, videá, hudba, zvuk
              a text patria GAMEBOX- u, alebo jednému z jeho spoločností a
              /alebo licenčných skupín, a sú chránené autorskými právami a
              /alebo inými právami duševného vlastníctva. Beriete týmto na
              vedomie, že pri používaní Služby nezískate žiadne práva na
              ochranné známky, alebo Obsah Služby, než ako je uvedené v tejto
              Dohode. Najmä za žiadnych okolností nemôžete skopírovať ľubovoľný
              Obsah Služby (vrátane a bez obmedzenia trivia otázky, odpovede,
              alebo hry), alebo využívať dolovanie dát, roboty, škrabanie
              obrazovky, alebo podobné zhromažďovanie údajov a extrakčné
              nástroje na Službe. Zodpovednosť Použitie GAMEBOX- u a /alebo web
              stránky GAMEBOX prebieha na vlastné riziko koncového užívateľa.
              Koncový užívateľ musí poskytnúť všetko- kompatibilný mobilný
              telefón, hardvér, alebo iné zariadenia a softvér, a zabezpečiť,
              aby boli v prevádzkyschopnom stave a vhodné na služby GAMEBOX.
              GAMEBOX nemôže zaručiť, že služby GAMEBOX spĺňajú požiadavky
              koncového užívateľa, a že stiahnutie, príjem a /alebo prezeranie
              služieb GAMEBOX bude bez prerušenia, alebo chýb. Ak kedykoľvek
              Koncový užívateľ nie je schopný používať bez prerušenia službu
              Puretech Global Sdn Bhd , v žiadnom prípade to nevedie k nároku na
              zníženie poplatkov za GAMEBOX služby, k akékoľvek právo na
              vrátenie platieb dopredu zaplatených. Akékoľvek použitie služieb
              GAMEBOX je podľa vlastného uváženia a rizika koncového užívateľa,
              a že za žiadny ale nie obmedzene, za infekcie, alebo kontaminácie,
              alebo straty dát, alebo poškodenie(ia) hardvéru a /alebo softvéru
              koncových užívateľov, vyplývajúcich z prístupu k webovým stránkam,
              alebo využívania služieb GAMEBOX -u, alebo stiahnutých GAMEBOX
              služieb, vrátane hardvéru a softvéru vyžadovaného na pripojenie k
              službám GAMEBOX. Je zodpovednosťou koncových užívateľov, aby
              prijali potrebné opatrenia, aby sa zabránilo možnému poškodeniu
              tohto druhu. V prípade, že GAMEBOX je z akéhokoľvek dôvodu povinný
              nahradiť koncovému užívateľovi priame, alebo následné škody
              akéhokoľvek druhu, takáto náhrada v žiadnom prípade nesmie
              prekročiť hodnotu faktúry za služby GAMEBOX, platených koncovým
              užívateľom pre údajné poškodenia. Obsah Webovej stránky bol
              zostavený s najväčšou starostlivosťou. Avšak, Miximo nemôže
              poskytnúť žiadnu záruku, pokiaľ ide o povahu, presnosť alebo obsah
              týchto informácií. GAMEBOX nenesie zodpovednosť za akékoľvek
              chyby, opomenutia, nepresnosti, nedorozumenia, oneskorenie, alebo
              nečitateľné objednávky, alebo oznámenia na základe používania
              Internetu, alebo príslušného informačného miesta. Záverečné
              ustanovenia Akékoľvek spory týkajúce sa plnenia týchto Obchodných
              podmienok budú riešené príslušnými všeobecnými súdmi. Puretech
              Global Sdn Bhd si vyhradzuje právo čas od času zmeniť tieto
              podmienky. Zmeny budú oznámené koncovým užívateľom vyvesením na
              portáli GAMEBOX.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: mapGetters(["host_gamebox", "countryCode"]),
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/gamebox/TermsSlovakia.vue